var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { query } from 'lit/decorators.js';
import { debounce, isEmpty, isNil } from 'lodash-es';
import { SdsInputBase } from '../_sds-input-base';
import { appendStylesToTheStyleRoot } from '../../utilities/dom';
import styles from './sds-textarea.lit.scss';
import stylesGlobal from './_sds-textarea-global.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
import { classMap } from 'lit/directives/class-map.js';
/**
 * `sds-textarea` is a web component for multi-line text input.
 * It provides a larger input field suited for entering longer text content.
 *
 * @tag sds-textarea
 */
let SdsTextarea = (() => {
    var _SdsTextarea__input_accessor_storage, _SdsTextarea__slotElement_accessor_storage, _SdsTextarea__wrapper_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-textarea')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsInputBase;
    let __input_decorators;
    let __input_initializers = [];
    let __input_extraInitializers = [];
    let __slotElement_decorators;
    let __slotElement_initializers = [];
    let __slotElement_extraInitializers = [];
    let __wrapper_decorators;
    let __wrapper_initializers = [];
    let __wrapper_extraInitializers = [];
    var SdsTextarea = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            this._stylesGlobal = stylesGlobal;
            _SdsTextarea__input_accessor_storage.set(this, __runInitializers(this, __input_initializers, void 0));
            _SdsTextarea__slotElement_accessor_storage.set(this, (__runInitializers(this, __input_extraInitializers), __runInitializers(this, __slotElement_initializers, void 0)));
            _SdsTextarea__wrapper_accessor_storage.set(this, (__runInitializers(this, __slotElement_extraInitializers), __runInitializers(this, __wrapper_initializers, void 0)));
            this.handleResize = __runInitializers(this, __wrapper_extraInitializers);
            this.handleInputDebounced = debounce(() => this.handleInput(), 100, {
                leading: true,
                trailing: true,
            });
        }
        get _input() { return __classPrivateFieldGet(this, _SdsTextarea__input_accessor_storage, "f"); }
        set _input(value) { __classPrivateFieldSet(this, _SdsTextarea__input_accessor_storage, value, "f"); }
        get _slotElement() { return __classPrivateFieldGet(this, _SdsTextarea__slotElement_accessor_storage, "f"); }
        set _slotElement(value) { __classPrivateFieldSet(this, _SdsTextarea__slotElement_accessor_storage, value, "f"); }
        get _wrapper() { return __classPrivateFieldGet(this, _SdsTextarea__wrapper_accessor_storage, "f"); }
        set _wrapper(value) { __classPrivateFieldSet(this, _SdsTextarea__wrapper_accessor_storage, value, "f"); }
        getInput() {
            return this._input;
        }
        willUpdate(changedProperties) {
            super.willUpdate(changedProperties);
            if (changedProperties.has('value')) {
                const hasError = this.value.length > this.maxLength;
                if (this.invalid !== hasError && !this.errorMessage) {
                    this.invalid = hasError;
                }
            }
        }
        updated(changedProperties) {
            super.updated(changedProperties);
            if (changedProperties.has('disabled')) {
                this.updateSlottedElementsDisabledState();
            }
            if (changedProperties.has('rows') || changedProperties.has('maxRows')) {
                if (this._input) {
                    this._input.style.height = `${20 * this.rows}px`;
                    if (this.autoResize) {
                        this.adjustRows();
                    }
                }
            }
        }
        render() {
            appendStylesToTheStyleRoot(this, 'sds-textarea', this._stylesGlobal.cssText);
            return html `
            <div class="${this.getClasses()}">
                <div class="sds-textarea__wrapper" part="sds-textarea-wrapper">
                    <textarea
                        id="${this.unique}"
                        class="sds-textarea__element"
                        part="sds-textarea"
                        autocomplete="off"
                        ?disabled="${this.disabled}"
                        placeholder="${this.placeholder}"
                        no-resize
                        maxlength="${this.maxLength}"
                        ?show-count="${this.showCount}"
                        value="${this.value}"
                        @input="${() => this.handleInput()}"
                        @focus="${() => this.handleFocus()}"
                        @blur="${() => this.handleBlur()}"
                        @keydown="${(event) => this.handleKeyDown(event)}"
                        @change="${() => this.handleChanged()}"
                    ></textarea>

                    ${this.renderToolbar()} ${this.renderActionContainer()}
                </div>

                ${this.renderMessages()}
            </div>
        `;
        }
        renderMessages() {
            if (this.hint || this.showCount || this.invalid) {
                return html `
                <div class="sds-textarea__messages">
                    ${this.renderHint()} ${this.renderError()} ${this.renderCount()}
                </div>
            `;
            }
        }
        renderToolbar() {
            if (this.withToolbar) {
                return html `
                <div class="sds-textarea-toolbar" part="sds-textarea-toolbar">
                    <slot></slot>
                </div>
            `;
            }
            else {
                return html ` <slot id="slot"></slot> `;
            }
        }
        renderCount() {
            if (this.showCount) {
                return html `
                <div
                    class="sds-textarea-count ${this.value.length > this.maxLength
                    ? 'sds-textarea-count--invalid'
                    : ''}"
                >
                    <span class="sds-textarea-count__current">${this.value.length}</span>
                    /
                    <span class="sds-textarea-count__maximum">${this.maxLength}</span>
                </div>
            `;
            }
        }
        firstUpdated() {
            var _a;
            this.hasClear = false;
            if (((_a = this._slotElement) === null || _a === void 0 ? void 0 : _a.assignedNodes({ flatten: true }).length) !== 0) {
                this._input.classList.add('sds-textarea__element--has-slot');
                this.updateSlottedElementsDisabledState();
            }
            // Add window resize listener for auto-resize
            if (this.autoResize) {
                this.handleResize = () => {
                    this.adjustRows();
                };
                window.addEventListener('resize', this.handleResize);
            }
            else {
                this.handleResize = () => { };
            }
            // Watch for style attribute changes on wrapper
            const observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    if (mutation.attributeName === 'style') {
                        this.style.height = 'unset';
                        this._input.style.height = '100%';
                        // Stop observing after first successful removal
                        observer.disconnect();
                    }
                });
            });
            observer.observe(this._wrapper, { attributes: true, attributeFilter: ['style'] });
        }
        handleInput() {
            super.handleInput();
            if (this.autoResize) {
                this.adjustRows();
            }
        }
        handleFocus() {
            super.handleFocus();
            if (this.autoResize && this.value && this.value.length > 0) {
                this.adjustRows();
            }
        }
        handleBlur() {
            super.handleBlur();
            // Scroll to top when textarea loses focus
            if (this._input) {
                this._input.scrollTop = 0;
            }
        }
        adjustRows() {
            const lineHeight = 20;
            // Adjust for toolbar height
            const baseHeight = 20;
            const maxHeight = this.maxRows ? this.maxRows * lineHeight : Infinity;
            // Set initial height based on rows
            this._input.style.height = `${baseHeight + (this.rows - 1) * lineHeight}px`;
            // Temporarily remove scrollbar to get accurate height
            const originalScrollbarWidth = this._input.style.scrollbarWidth;
            this._input.style.scrollbarWidth = 'none';
            const newHeight = this._input.scrollHeight;
            // Restore scrollbar
            this._input.style.scrollbarWidth = originalScrollbarWidth;
            const cappedHeight = newHeight >= maxHeight ? maxHeight : newHeight;
            // Calculate how many rows we actually need
            const neededRows = Math.ceil((cappedHeight - baseHeight + lineHeight) / lineHeight);
            const finalRows = Math.max(1, neededRows); // At least 1 row
            // Set final height
            this._input.style.height = `${baseHeight + (finalRows - 1) * lineHeight}px`;
            if (newHeight > maxHeight) {
                this._input.scrollTop = 0;
            }
        }
        showClear() {
            return (!isNil(this.value) &&
                !isEmpty(this.value.toString()) &&
                !this.disabled &&
                this.hasClear &&
                this.rightAligned);
        }
        emptyValue() {
            return '';
        }
        convertValue(value) {
            return value;
        }
        updateSlottedElementsDisabledState() {
            if (!this._slotElement)
                return;
            const slottedElements = this._slotElement.assignedElements();
            slottedElements.forEach(element => {
                if (this.disabled) {
                    element.setAttribute('disabled', '');
                }
                else {
                    element.removeAttribute('disabled');
                }
            });
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            // Clean up window resize listener
            if (this.handleResize) {
                window.removeEventListener('resize', this.handleResize);
            }
        }
        getClasses() {
            return classMap({
                'sds-textarea': true,
                'sds-textarea--focused': this.focused,
                'sds-textarea--disabled': this.disabled,
                'sds-textarea--invalid': this.invalid,
                'sds-textarea--no-resize': this.noResize || this.autoResize,
                'sds-textarea--with-toolbar': this.withToolbar,
                'sds-textarea--with-hint': this.hint || this.showCount,
            });
        }
    };
    _SdsTextarea__input_accessor_storage = new WeakMap();
    _SdsTextarea__slotElement_accessor_storage = new WeakMap();
    _SdsTextarea__wrapper_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTextarea");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __input_decorators = [query('.sds-textarea__element')];
        __slotElement_decorators = [query('#slot')];
        __wrapper_decorators = [query('.sds-textarea__wrapper')];
        __esDecorate(_classThis, null, __input_decorators, { kind: "accessor", name: "_input", static: false, private: false, access: { has: obj => "_input" in obj, get: obj => obj._input, set: (obj, value) => { obj._input = value; } }, metadata: _metadata }, __input_initializers, __input_extraInitializers);
        __esDecorate(_classThis, null, __slotElement_decorators, { kind: "accessor", name: "_slotElement", static: false, private: false, access: { has: obj => "_slotElement" in obj, get: obj => obj._slotElement, set: (obj, value) => { obj._slotElement = value; } }, metadata: _metadata }, __slotElement_initializers, __slotElement_extraInitializers);
        __esDecorate(_classThis, null, __wrapper_decorators, { kind: "accessor", name: "_wrapper", static: false, private: false, access: { has: obj => "_wrapper" in obj, get: obj => obj._wrapper, set: (obj, value) => { obj._wrapper = value; } }, metadata: _metadata }, __wrapper_initializers, __wrapper_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTextarea = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTextarea = _classThis;
})();
export { SdsTextarea };
